export default {
  baseStyle: {
    opacity: 1,
  },
};
